import styled, { css } from 'styled-components';

export const ShareSection = styled.div`
  position: absolute;
  max-width: 10%;
  ${(props) =>
    props.newStyle
      ? css`
          right: 8px;
          top: 8px;
          z-index: 17;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 34px;
          height: 34px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 4px 8px rgba(154, 183, 188, 0.24);

          img {
            width: 27px;
            height: 27px;
          }

          @media (min-width: 768px) {
            max-width: 7%;
            cursor: pointer;
          }
        `
      : css`
          right: 0;
          img {
            width: 24px;
            height: 24px;
          }
          @media (min-width: 768px) {
            max-width: 7%;
            right: 12%;
            cursor: pointer;
          }
        `}
`;
export const ShareSectionNew = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(154, 183, 188, 0.24);
  img {
    width: 18px;
    height: 18px;
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 10px;
  justify-content: space-evenly;
`;

export const ShareContainer = styled.div`
  height: 100px;
  background: #fff;
`;
export const ShareButtonPdp = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  &.lowOpacity {
    opacity: 0.5;
  }
  img {
    min-width: 70%;
    @media (min-width: 768px) {
      min-width: 60%;
    }
  }
  span {
    font-size: clamp(14px, 3vw, 16px);
    margin-bottom: 5px;
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;
